<template>
  <div class="employee-notification employee-notificaton-wrapper">
    <div class="pl-4 pt-4">
      <div class="logo-wrapper">
        <img :src="require('@components/assets/info-circle.svg')" alt="" class="logo-img">
      </div>
    </div>
    <div class="py-4">
      <div class="notification-title">You have {{ props.activeEmployeesWithNoaccess }} active employees that have no access to their exIQtive Employee account</div>
      <div class="notification-description">{{ props.description }}</div>
      <div class="notification-action" @click="filterEmployees">{{ props.actionLabel }}</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  activeEmployeesWithNoaccess: {
    type: Number,
    default: 0
  },
  description: {
    type: String,
    default: ""
  },
  actionLabel: {
    type: String,
    default: "Filter Employees with No Action"
  }
});

const emit = defineEmits(['isFilter']);

const filterEmployees = () => {
  emit('isFilter', true);
};
</script>

<style>
.employee-notification.employee-notificaton-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid  #D0D5DD;
  background: #FFF;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.employee-notification .logo-wrapper {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius:  8px;
  border: 1px solid #EAECF0;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.employee-notification .notification-title {
  color: #344054;
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}
.employee-notification .notification-description {
  color:  #475467;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;;
  line-height: 20px;
  margin-bottom: 12px;
}
.employee-notification .notification-action {
  color: #6941C6;
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}
.employee-notification .logo-img {
  width: 100%;
}
</style>